import { Selector } from '../../types';
import { IGetRestaurantResponse } from '../../../proto/restaurant/restaurant';

export const selectUserSelectedRestaurantId: Selector<IGetRestaurantResponse['id']> = (state) => state.auth?.selectedRestaurantId;
export const selectCsrfToken: Selector<string | undefined> = (state) => state.auth?.csrfToken;
